import { useEffect } from 'react'
import { v4 } from 'uuid'
import { useSceneStore } from '@editor/stores'

const useCameraEvent = (event: CameraEvents | null) => {
  const addCameraEvent = useSceneStore(state => state.addCameraEvent)
  const removeCameraEvent = useSceneStore(state => state.removeCameraEvent)

  useEffect(() => {
    if (!event) return

    const guid = v4()

    addCameraEvent({ guid, event })

    return () => {
      removeCameraEvent(guid)
    }
  }, [addCameraEvent, event, removeCameraEvent])
}

export default useCameraEvent
